/**
 * Subtitle/CC debug logging + overlay. OFF by default everywhere (including dev).
 * Opt in from the console with:
 *   localStorage.setItem('pixley_subtitle_debug', '1')
 * and turn off with:
 *   localStorage.removeItem('pixley_subtitle_debug')
 */
export const isSubtitleDebugEnabled = () =>
  typeof window !== 'undefined' &&
  window.localStorage?.getItem('pixley_subtitle_debug') === '1';

export const subtitleDebug = (scope, message, data) => {
  if (!isSubtitleDebugEnabled()) return;
  if (data !== undefined) {
    console.log(`[CC DEBUG][${scope}] ${message}`, data);
  } else {
    console.log(`[CC DEBUG][${scope}] ${message}`);
  }
};

export const logTextTracks = (video, scope = 'textTracks') => {
  if (!isSubtitleDebugEnabled() || !video?.textTracks) return [];
  const tracks = [];
  for (let i = 0; i < video.textTracks.length; i++) {
    const track = video.textTracks[i];
    tracks.push({
      index: i,
      language: track.language,
      label: track.label,
      kind: track.kind,
      mode: track.mode,
    });
  }
  subtitleDebug(scope, `textTracks.length=${video.textTracks.length}`, tracks);
  return tracks;
};
